module.exports = __webpack_public_path__ + "static/media/aptoMedico.3c32b7fb.pdf";